module.exports = __webpack_public_path__ + "static/media/pink_nebula_RT.c4ef61fe.png";